
import React from "react";
import ShopifyModal from "../../../../../components/ShopifyModal";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import utils from '../../../../../utils/utils'
import intl from "../../../../../i18n/intl";
const UpgradePlanModal = ({upgradeOpen,setUpgradeOpen}) => {
    const router  = useHistory()

  return (
    <div className="upgrade_new_feature">
      <ShopifyModal id="premium-plan-modal"
        open={upgradeOpen}
        onClose={() => setUpgradeOpen()}
        heading={intl.get('Premium Plan Required')}
        primaryAction={{
          content: intl.get("Upgrade"),
          onAction: () => {
            setUpgradeOpen()
            // utils.routeListen('/admin/subscribe')
            utils.routeJump1(router,'/admin/subscribe')
          },
        }}
        secondaryActions={[
          {
            content: intl.get("Cancel"),
            onAction: () => setUpgradeOpen(),
          },
        ]}
      >
        <p style={{fontSize:'14px'}}>{intl.get('Package ordering is only available with the Premium Plan. Please upgrade your plan!')}</p>
        </ShopifyModal>
    </div>
  );
};

export default UpgradePlanModal;
